import "./App.css";
import { handleLogout, idealTimer } from "./components/Header/utils";
import { useState } from "react";
import { Spin } from "antd";
import Login from "./pages/login";
import Router from "./router/router";
import { useUser } from "./user-context";
import SessionExpire from "./components/IdleTimer/session-expire";
import { BrowserRouter } from "react-router-dom";

const App = () => {
  const { userRole, isAuthenticated, setIsAuthenticated } = useUser();
  const authDataString = sessionStorage?.getItem("isAuthenticated");
  const [isLoginPage, setIsLoginPage] = useState<boolean>(true);
  const hideLoginPage = (hide: boolean) => {
    setIsLoginPage(hide);
  };

  if (
      authDataString !== "true" &&
      isAuthenticated === false &&
      isLoginPage === true
    ) {
      return (
        <BrowserRouter>
          <Login
            setIsAuthenticated={setIsAuthenticated}
            isAuthenticated={isAuthenticated}
            hideLoginPage={hideLoginPage}
          />
        </BrowserRouter>
      );
    }
    if (
      userRole === null &&
      isAuthenticated === true &&
      isLoginPage === false
    ) {
      return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
          <Spin />
        </div>
      );
    }

  return (
    <>
      <Router isAuthenticated={isAuthenticated} userRole={userRole} />
      <SessionExpire onIdle={handleLogout} timeout={idealTimer} />
    </>
  );
};

export default App;
